const serviceCategories = [
  {
    title: "Software Engineering",
    description:
      "We engineer robust digital solutions that solve real business challenges, streamline operations, and create exceptional user experiences. From websites and enterprise systems to mobile applications and scalable APIs, we build secure, high-performance software designed to grow alongside your business while supporting long-term innovation and operational efficiency.",
    services: [
      {
        title: "Custom Software Development",
        tagline:
          "Purpose-built software tailored to your unique workflows, goals, and business processes.",
        image:
          "https://images.pexels.com/photos/39284/macbook-apple-imac-computer-39284.jpeg",
      },
      {
        title: "Website Development",
        tagline:
          "Professional, responsive websites designed to convert visitors into customers.",
        image:
          "https://images.pexels.com/photos/30885764/pexels-photo-30885764.jpeg",
      },
      {
        title: "Web Applications",
        tagline:
          "Scalable web applications built for performance, collaboration, and business growth.",
        image:
          "https://images.pexels.com/photos/1181675/pexels-photo-1181675.jpeg",
      },
      {
        title: "Mobile Application Development",
        tagline:
          "High-quality Android and iOS apps that deliver seamless user experiences.",
        image:
          "https://images.pexels.com/photos/3850263/pexels-photo-3850263.jpeg",
      },
      {
        title: "API Development & Integration",
        tagline:
          "Secure APIs that connect systems, automate workflows, and enable seamless data exchange.",
        image:
          "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg",
      },
    ],
  },

  {
    title: "Product Design",
    description:
      "Great products begin with great experiences. We combine user research, strategic thinking, and thoughtful design to create intuitive digital products that are visually engaging, easy to use, and aligned with your business objectives. Every design decision is made to improve usability, increase engagement, and maximize value.",
    services: [
      {
        title: "UI/UX Design",
        tagline:
          "Human-centered interfaces that balance aesthetics, usability, and accessibility.",
        image:
          "https://images.pexels.com/photos/196644/pexels-photo-196644.jpeg",
      },
      {
        title: "Wireframing & Prototyping",
        tagline:
          "Visualize, validate, and refine ideas before investing in development.",
        image:
          "https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg",
      },
      {
        title: "Product Strategy",
        tagline:
          "Transform ideas into successful digital products with a clear execution roadmap.",
        image:
          "https://images.pexels.com/photos/7947841/pexels-photo-7947841.jpeg",
      },
    ],
  },

  {
    title: "Growth & Visibility",
    description:
      "Building a great product is only the beginning. We help businesses establish a strong digital presence through strategic branding, search optimization, and engaging content that increases visibility, attracts the right audience, and supports sustainable business growth in competitive markets.",
    services: [
      {
        title: "Search Engine Optimization (SEO)",
        tagline:
          "Improve search rankings and attract qualified traffic that converts.",
        image:
          "https://images.pexels.com/photos/7661068/pexels-photo-7661068.jpeg",
      },
      {
        title: "Social Media Management",
        tagline:
          "Create consistent digital engagement that builds trust and strengthens your brand.",
        image:
          "https://images.pexels.com/photos/5053846/pexels-photo-5053846.jpeg",
      },
      {
        title: "Brand Strategy",
        tagline:
          "Develop a compelling brand identity that differentiates and inspires confidence.",
        image:
          "https://images.pexels.com/photos/7947841/pexels-photo-7947841.jpeg",
      },
    ],
  },

  {
    title: "Innovation & Automation",
    description:
      "We help organizations embrace the future through intelligent automation and emerging technologies. By integrating AI, optimizing business processes, and providing strategic digital transformation guidance, we enable businesses to operate more efficiently, make smarter decisions, and remain competitive in an evolving digital landscape.",
    services: [
      {
        title: "AI Integration",
        tagline:
          "Embed intelligent capabilities into your systems to automate, analyze, and innovate.",
        image:
          "https://images.pexels.com/photos/8386440/pexels-photo-8386440.jpeg",
      },
      {
        title: "Business Process Automation",
        tagline:
          "Automate repetitive workflows to improve productivity, accuracy, and efficiency.",
        image:
          "https://images.pexels.com/photos/33137134/pexels-photo-33137134.jpeg",
      },
      {
        title: "Digital Transformation Consulting",
        tagline:
          "Strategic technology guidance that accelerates sustainable digital growth.",
        image:
          "https://images.pexels.com/photos/7947841/pexels-photo-7947841.jpeg",
      },
    ],
  },

  {
    title: "Support & Enablement",
    description:
      "Technology should continue delivering value long after deployment. We provide ongoing maintenance, technical support, and knowledge transfer to ensure your digital solutions remain secure, reliable, and adaptable while empowering your team with the skills needed to succeed.",
    services: [
      {
        title: "Website & System Maintenance",
        tagline:
          "Proactive maintenance that keeps your platforms secure, stable, and performing optimally.",
        image:
          "https://images.pexels.com/photos/577585/pexels-photo-577585.jpeg",
      },
      {
        title: "Technical Mentorship & Training",
        tagline:
          "Practical training that equips individuals and teams with real-world technical skills.",
        image:
          "https://images.pexels.com/photos/1181359/pexels-photo-1181359.jpeg",
      },
    ],
  },
];

export default serviceCategories;